import { useMemo } from 'react';
import { Image, XStack } from 'smoothie';

import { useGetActiveGuides } from '../hooks/useGetActiveGuides';

type SIZE = 'small' | 'medium' | 'large';

const SIZE_MAP = {
    small: 30,
    medium: 44,
    large: 56,
};
const MARGIN_MAP = {
    small: -18,
    medium: -20,
    large: -24,
};

const GuideAvatars = ({
    size = 'large',
    count = 4,
}: {
    size?: SIZE;
    count?: number;
}) => {
    const { data: guides } = useGetActiveGuides({});

    const selected = useMemo(() => {
        const shuffled = [...(guides ?? [])].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, count);
    }, [guides, count]);

    return (
        <XStack>
            {selected.map((guide, index) => (
                <Image
                    key={guide.id}
                    source={{ uri: guide.profileImageUrl ?? '' }}
                    width={SIZE_MAP[size]}
                    height={SIZE_MAP[size]}
                    borderRadius={SIZE_MAP[size] / 2}
                    marginRight={
                        index === selected.length - 1 ? 0 : MARGIN_MAP[size]
                    }
                    zIndex={index}
                />
            ))}
        </XStack>
    );
};

export default GuideAvatars;
